import { useMutation } from '@tanstack/react-query';

import { paymentTypeTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

const validatePaymentTypeKey: paymentTypeTypes.ValidatePaymentTypeKey = (
  data
): Promise<{ exists: boolean }> => {
  return axios.post(`/payment-types/keys/validate`, data);
};

type ValidatePaymentTypeKeyOptions = {
  config?: MutationConfig<typeof validatePaymentTypeKey>;
};

export function useValidatePaymentTypeKey({ config = {} }: ValidatePaymentTypeKeyOptions = {}) {
  return useMutation({
    ...config,
    mutationFn: validatePaymentTypeKey,
  });
}
